import Header from './Header'
import PullToRefresh from './PullToRefresh'
import BottomTabBar from './BottomTabBar'

function Layout({ currentPage, onNavigate, terms, activeTermId, onSwitchTerm, onSignOut, onRefresh, children }) {
  return (
    <div className="app-layout">
      <Header currentPage={currentPage} onNavigate={onNavigate} terms={terms} activeTermId={activeTermId} onSwitchTerm={onSwitchTerm} onSignOut={onSignOut} />
      <PullToRefresh onRefresh={onRefresh}>
        <main className="app-main">
          {children}
        </main>
      </PullToRefresh>
      <BottomTabBar currentPage={currentPage} onNavigate={onNavigate} onSignOut={onSignOut} />
    </div>
  )
}

export default Layout
